import { render, staticRenderFns } from "./ReloanAmount.vue?vue&type=template&id=588d5f14&scoped=true&"
import script from "./ReloanAmount.vue?vue&type=script&lang=js&"
export * from "./ReloanAmount.vue?vue&type=script&lang=js&"
import style0 from "./ReloanAmount.vue?vue&type=style&index=0&id=588d5f14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588d5f14",
  null
  
)

export default component.exports